// extracted by mini-css-extract-plugin
export default {"button":"CustomMenuItem_button__Pvr5e","button__description":"CustomMenuItem_button__description__bItDE"};